import { colors } from '@/themes';

export enum SkillName {
    Vocabulary = 'vocabulary',
    Grammar = 'grammar',
    Speaking = 'speaking',
    Listening = 'listening',
    Reading = 'reading',
    Writing = 'writing',
    All = 'all',
}

export const skillColor = {
    [SkillName.Vocabulary]: colors.blue[300],
    [SkillName.Grammar]: colors.lightGreen[300],
    [SkillName.Listening]: colors.green[300],
    [SkillName.Speaking]: colors.purple[300],
    [SkillName.Reading]: colors.primary,
    [SkillName.Writing]: colors.grey[850],
    [SkillName.All]: colors.red[200],
};
export const skillColorAlpha = {
    [SkillName.Vocabulary]: '#3498db40',
    [SkillName.Grammar]: '#1abc9c40',
    [SkillName.Listening]: '#2ecc7140',
    [SkillName.Speaking]: '#9b59b640',
    [SkillName.Reading]: '#e67e2240',
    [SkillName.Writing]: '#34495e40',
    [SkillName.All]: '#e74c3c40',
};
export const skillBackground = {
    [SkillName.Vocabulary]: '#3498db0f',
    [SkillName.Grammar]: '#1abc9c0f',
    [SkillName.Listening]: '#2ecc710f',
    [SkillName.Speaking]: '#9b59b60f',
    [SkillName.Reading]: '#e67e220f',
    [SkillName.Writing]: '#34495e0f',
    [SkillName.All]: '#e74c3c0f',
};
export const skillProgressBackground = {
    [SkillName.Vocabulary]: '#3498db14',
    [SkillName.Grammar]: '#1abc9c14',
    [SkillName.Listening]: '#2ecc7114',
    [SkillName.Speaking]: '#9b59b614',
    [SkillName.Reading]: '#e67e2214',
    [SkillName.Writing]: '#34495e14',
    [SkillName.All]: '#e74c3c14',
};

export enum Difficulty {
    Beginner = 'beginner',
    Medium = 'medium',
    Elementary = 'elementary',
    Intermediate = 'intermediate',
    UpperIntermediate = 'upper_intermediate',
    Advanced = 'advanced',
    Expert = 'expert',
}

export enum CefrLevel {
    A0 = 'A0',
    A1 = 'A1',
    A2 = 'A2',
    B0 = 'B0',
    B1 = 'B1',
    B2 = 'B2',
    C0 = 'C0',
    C1 = 'C1',
    C2 = 'C2',
}

export const DEFAULT_OPTION = 'all';

export enum PracticeMode {
    Selection = 'selection',
    Practice = 'practice',
    Results = 'results',
}

export const START_PAGE = 1;

export enum MODAL {
    SURVEY = 'survey',
    EXPLORE_TOPICS = 'exploreTopics',
    ASSESSMENT = 'assessment',
}

export enum SEVERITY_NOTIFICATION {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning',
}

export const DEFAULT_FIRST_PAGE = 1;
export const DEFAULT_LIMIT_FOR_PAGINATION = 20;
export const DEFAULT_NOTIFICATION_DURATION = 3000;

export const SIZE_PAGE_OPTIONS = [
    { value: 12, label: 12 },
    { value: 24, label: 24 },
    { value: 36, label: 36 },
];